import { useCallback, useState } from "react";

import { LoginData, LoginUIProps } from "./Login.types.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

export const useLogin = (): LoginUIProps => {
  const { onLogin } = useLoginContext();

  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState<LoginData>({
    email: "",
    password: "",
  });

  const handleShowPassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const form = e.currentTarget;
      const isValid = form.checkValidity();
      setValidated(true);

      if (!isValid) return;

      await onLogin(formData);
    },
    [formData, onLogin]
  );

  return {
    formData,
    validated,
    showPassword,
    handleChange,
    handleSubmit,
    handleShowPassword,
  };
};
